import * as React from "react";

export type BrandDetailsTab = "styles" | "context";

interface BrandDetailsContextType {
  selectedTab: BrandDetailsTab;
  setSelectedTab: (tab: BrandDetailsTab) => void;
}

const BrandDetailsContext = React.createContext<
  BrandDetailsContextType | undefined
>(undefined);

export const BrandDetailsProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [selectedTab, setSelectedTab] =
    React.useState<BrandDetailsTab>("styles");

  return (
    <BrandDetailsContext.Provider value={{ selectedTab, setSelectedTab }}>
      {children}
    </BrandDetailsContext.Provider>
  );
};

export const useBrandDetailsTabs = () => {
  const context = React.useContext(BrandDetailsContext);
  if (context === undefined) {
    // eslint-disable-next-line replo/no-raw-error-throw
    throw new Error(
      "useBrandDetails must be used within a BrandDetailsProvider",
    );
  }
  return context;
};
